import React, { Component } from "react";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { unscaledStart, unscaledDrag, end, getUnscaledTarget } from "./hotspot";
import { injectIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import {
  setCellCulture,
  setGelPrediction,
  setHeldObject,
  removeCellCultureType,
} from "./store/actions";

import "./styles.scss";

import dragIcon from "./img/drag-icon.svg";
import wildType from "./img/cell_culture-wild_type.svg";
import pancreasCells from "./img/cell_culture-pancreas_cells.svg";
import edit7 from "./img/cell_culture-edit_7.svg";
import edit4 from "./img/cell_culture-edit_4.svg";
import protein1 from "./img/protein_gel-1.svg";
import protein2 from "./img/protein_gel-2.svg";
import protein3 from "./img/protein_gel-3.svg";
import protein4 from "./img/protein_gel-4.svg";
import iconCorrect from "./img/icon_correct.svg";
import iconIncorrect from "./img/icon_incorrect.svg";
import close from "./img/close.svg";

const images = {
  wildType: wildType,
  pancreasCells: pancreasCells,
  edit7: edit7,
  edit4: edit4,
};

class Prediction510 extends Component {
  gels = {
    protein1: {
      image: protein1,
      message: this.props.intl.formatMessage({
        id: "This gel needs to run longer. The proteins have not separated enough.",
        defaultMessage:
          "This gel needs to run longer. The proteins have not separated enough.",
        description: "",
      }),
    },
    protein2: {
      image: protein2,
      message: this.props.intl.formatMessage({
        id: "This gel has not run yet. The samples are still in the wells of the gel.",
        defaultMessage:
          "This gel has not run yet. The samples are still in the wells of the gel.",
        description: "",
      }),
    },
    protein3: {
      image: protein3,
      message: this.props.intl.formatMessage({
        id: "The gel has run all the way to the end, and the proteins are optimally separated for analysis.",
        defaultMessage:
          "The gel has run all the way to the end, and the proteins are optimally separated for analysis.",
        description: "",
      }),
    },
    protein4: {
      image: protein4,
      message: this.props.intl.formatMessage({
        id: "This gel has been running for too long. Your samples have run off the gel surface and are now lost in the buffer.",
        defaultMessage:
          "This gel has been running for too long. Your samples have run off the gel surface and are now lost in the buffer.",
        description: "",
      }),
    },
  };

  constructor(props) {
    super(props);

    this.state = {
      borders: {
        protein1: "",
        protein2: "",
        protein3: "",
        protein4: "",
      },
      display: {
        protein1: "none",
        protein2: "none",
        protein3: "none",
        protein4: "none",
      },
      predictionProtein: null,
      targetList: [],
      solutionMoveMenu: [false, false, false, false],
    };
  }

  componentDidMount() {
    this.setState({
      targetList: [
        document.getElementById("dropzone-0"),
        document.getElementById("dropzone-1"),
        document.getElementById("dropzone-2"),
        document.getElementById("drop-target"),
      ],
    });
  }

  teleport = (id, targetId) => {
    const cellCultures = ["wildType", "pancreasCells", "edit4", "edit7"];
    const type = cellCultures[id];

    this.props.setCellCulture({
      id: targetId,
      type: type,
    });
  };

  moveTo = (id, targetId) => {
    const solutionMoveMenu = this.state.solutionMoveMenu;

    this.setState({
      solutionMoveMenu: solutionMoveMenu,
    });

    this.teleport(id, targetId);
  };

  showMoveMenu = (e, index) => {
    // Hide all the menus
    const solutionMoveMenu = this.state.solutionMoveMenu;

    solutionMoveMenu.forEach(function (solution, innerIndex, arr) {
      if (index !== innerIndex) {
        arr[innerIndex] = false;
      }
    });

    // Toggle this menu
    solutionMoveMenu[index] = !solutionMoveMenu[index];

    if (solutionMoveMenu[index] == true) {
      const elems = document.getElementsByClassName("solution");
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.zIndex = null;
      }
      e.target.parentNode.style.zIndex = 99;
    } else {
      e.target.parentNode.style.zIndex = null;
    }

    this.setState({
      solutionMoveMenu: solutionMoveMenu,
    });
  };

  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }
    dragImage.style.position = "absolute";
    dragImage.style.top = 0;
    dragImage.style.left = 0;

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    if (e.target.id.includes("cellculture-")) {
      const tempId = parseInt(e.target.id.split("-")[1]);

      this.props.setHeldObject({
        type: "Solution",
        id: tempId,
        htmlObj: e.target,
      });
    }

    unscaledStart(e, e.target);
  };

  drag = throttle((event) => {
    unscaledDrag(event);
  }, 20);

  onDragOver = (e) => {
    e.preventDefault();
    e.persist();
    this.drag(e);
  };

  onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const target = getUnscaledTarget(
      this.props.heldObject.htmlObj,
      this.state.targetList
    );

    if (target !== "") {
      if (target.id.includes("dropzone-")) {
        const targetId = parseInt(target.id.split("-")[1]);

        const cellCultures = ["wildType", "pancreasCells", "edit4", "edit7"];
        const type = cellCultures[this.props.heldObject.id];

        this.props.setCellCulture({
          id: targetId,
          type: type,
        });

        this.props.setHeldObject({
          type: null,
          id: -1,
          htmlObj: null,
        });

        this.props.heldObject.htmlObj.style.transform =
          "translate3d(0px, 0px, 0px) rotateZ(0deg)";
      } else {
        this.props.heldObject.htmlObj.style.transform =
          "translate3d(0px, 0px, 0px) rotateZ(0deg)";
      }
    } else {
      this.props.heldObject.htmlObj.style.transform =
        "translate3d(0px, 0px, 0px) rotateZ(0deg)";
    }

    end(e);
  };

  removeCellCulture = (lane, index) => {
    this.props.removeCellCultureType({
      id: lane,
      index: index,
    });
  };

  showPredictionPopup = () => {
    this.props.setGelPrediction({
      predictionProtein: this.state.predictionProtein,
    });

    this.setState({ predictionProtein: null });
  };

  parseTypeKey = (key) => {
    const refs = {
      wildType: "Wild type cells.",
      pancreasCells: "Pancreas cells.",
      edit4: "Edit 4 cells.",
      edit7: "Edit 7 cells.",
    };

    return refs[key];
  };

  sectionDragAndDrop = () => {
    return (
      <div>
        <div className="innerQBlock" style={{ paddingBottom: "16px" }}>
          <div className="dnd-bg">
            <div className="dnd-bg-padding">
              <h5 className="heading5">
                <FormattedMessage
                  id="Identify controls and samples"
                  defaultMessage="Identify controls and samples"
                  description=""
                />
              </h5>

              <p>
                <FormattedMessage
                  id="Below are four different cell cultures: your two CRISPR-edited cell lines as well as the wild type macrophage and the pancreas cells. Drag and drop each cell culture into the correct box below as either the positive control, the negative control, or your samples of interest. Use each culture once."
                  defaultMessage="Below are four different cell cultures: your two CRISPR-edited cell lines as well as the wild type macrophage and the pancreas cells. Drag and drop each cell culture into the correct box below as either the positive control, the negative control, or your samples of interest. Use each culture once."
                  description=""
                />
              </p>

              <div className="drag">
                <div className="drag__indicator">
                  <img id="drag-icon-img" src={dragIcon} alt="" />
                  <div>
                    <FormattedMessage
                      id="drag"
                      defaultMessage="drag"
                      description=""
                    />
                  </div>
                </div>

                <div className="drag__cell-culture">
                  <div
                    draggable="true"
                    id="cellculture-0"
                    className="drag__cell-culture--type"
                    style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
                    onClick={(e) => {
                      this.showMoveMenu(e, 0);
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13 || e.keyCode === 32) {
                        this.showMoveMenu(e, 0);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label={this.props.intl.formatMessage({
                      id: "Wild type cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      defaultMessage:
                        "Wild type cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      description: "",
                    })}
                  >
                    <img
                      draggable="false"
                      src={images.wildType}
                      alt={this.props.intl.formatMessage({
                        id: "Wild type cells",
                        defaultMessage: "Wild type cells",
                        description: "",
                      })}
                      aria-hidden="true"
                    />
                    <div
                      className="solution-move-menu"
                      style={{
                        display: this.state.solutionMoveMenu[0] ? null : "none",
                      }}
                      aria-hidden="true"
                    >
                      <h7>Move to:</h7>
                      <div>
                        <button
                          onClick={() => {
                            this.moveTo(0, 1);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as positive control.",
                            defaultMessage: "Identify as positive control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Positive control"
                            defaultMessage="Positive control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(0, 2);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as negative control.",
                            defaultMessage: "Identify as negative control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Negative control"
                            defaultMessage="Negative control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(0, 0);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as sample of interest.",
                            defaultMessage: "Identify as sample of interest.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Sample of interest"
                            defaultMessage="Sample of interest"
                            description=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    draggable="true"
                    id="cellculture-1"
                    className="drag__cell-culture--type"
                    style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      this.showMoveMenu(e, 1);
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13 || e.keyCode === 32) {
                        this.showMoveMenu(e, 1);
                      }
                    }}
                    aria-label={this.props.intl.formatMessage({
                      id: "Pancreas cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      defaultMessage:
                        "Pancreas cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      description: "",
                    })}
                  >
                    <img
                      draggable="false"
                      src={images.pancreasCells}
                      alt={this.props.intl.formatMessage({
                        id: "Pancreas cells",
                        defaultMessage: "Pancreas cells",
                        description: "",
                      })}
                      aria-hidden="true"
                    />
                    <div
                      className="solution-move-menu"
                      style={{
                        display: this.state.solutionMoveMenu[1] ? null : "none",
                      }}
                      aria-hidden="true"
                    >
                      <h7>Move to:</h7>
                      <div>
                        <button
                          onClick={() => {
                            this.moveTo(1, 1);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as positive control.",
                            defaultMessage: "Identify as positive control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Positive control"
                            defaultMessage="Positive control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(1, 2);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as negative control.",
                            defaultMessage: "Identify as negative control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Negative control"
                            defaultMessage="Negative control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(1, 0);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as sample of interest.",
                            defaultMessage: "Identify as sample of interest.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Sample of interest"
                            defaultMessage="Sample of interest"
                            description=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    draggable="true"
                    id="cellculture-1"
                    className="drag__cell-culture--type"
                    style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      this.showMoveMenu(e, 1);
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13 || e.keyCode === 32) {
                        this.showMoveMenu(e, 1);
                      }
                    }}
                    aria-label={this.props.intl.formatMessage({
                      id: "Edit 4 cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      defaultMessage:
                        "Edit 4 cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      description: "",
                    })}
                  >
                    <img
                      draggable="false"
                      src={images.edit4}
                      alt={this.props.intl.formatMessage({
                        id: "Edit 4 cells",
                        defaultMessage: "Edit 4 cells",
                        description: "",
                      })}
                      aria-hidden="true"
                    />
                    <div
                      className="solution-move-menu"
                      style={{
                        display: this.state.solutionMoveMenu[1] ? null : "none",
                      }}
                      aria-hidden="true"
                    >
                      <h7>Move to:</h7>
                      <div>
                        <button
                          onClick={() => {
                            this.moveTo(1, 1);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as positive control.",
                            defaultMessage: "Identify as positive control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Positive control"
                            defaultMessage="Positive control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(1, 2);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as negative control.",
                            defaultMessage: "Identify as negative control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Negative control"
                            defaultMessage="Negative control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(1, 0);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as sample of interest.",
                            defaultMessage: "Identify as sample of interest.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Sample of interest"
                            defaultMessage="Sample of interest"
                            description=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    draggable="true"
                    id="cellculture-3"
                    className="drag__cell-culture--type"
                    style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
                    role="button"
                    tabIndex={0}
                    onClick={(e) => {
                      this.showMoveMenu(e, 3);
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13 || e.keyCode === 32) {
                        this.showMoveMenu(e, 3);
                      }
                    }}
                    aria-label={this.props.intl.formatMessage({
                      id: "Edit 7 cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      defaultMessage:
                        "Edit 7 cell culture. Select to identify as either the positive control, the negative control, or your samples of interest.",
                      description: "",
                    })}
                  >
                    <img
                      draggable="false"
                      src={images.edit7}
                      alt={this.props.intl.formatMessage({
                        id: "Edit 7 cells",
                        defaultMessage: "Edit 7 cells",
                        description: "",
                      })}
                      aria-hidden="true"
                    />
                    <div
                      className="solution-move-menu"
                      style={{
                        display: this.state.solutionMoveMenu[3] ? null : "none",
                      }}
                      aria-hidden="true"
                    >
                      <h7>Move to:</h7>
                      <div>
                        <button
                          onClick={() => {
                            this.moveTo(3, 1);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as positive control.",
                            defaultMessage: "Identify as positive control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Positive control"
                            defaultMessage="Positive control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(3, 2);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as negative control.",
                            defaultMessage: "Identify as negative control.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Negative control"
                            defaultMessage="Negative control"
                            description=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            this.moveTo(3, 0);
                          }}
                          aria-label={this.props.intl.formatMessage({
                            id: "Identify as sample of interest.",
                            defaultMessage: "Identify as sample of interest.",
                            description: "",
                          })}
                        >
                          <FormattedMessage
                            id="Sample of interest"
                            defaultMessage="Sample of interest"
                            description=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cell-culture-table">
                <div className="cell-culture-table__title-box">
                  <div className="cell-culture-table__title-box__title">
                    <FormattedMessage
                      id="Positive control"
                      defaultMessage="Positive control"
                      description=""
                    />
                  </div>
                  <div className="cell-culture-table__title-box__title">
                    <FormattedMessage
                      id="Negative control"
                      defaultMessage="Negative control"
                      description=""
                    />
                  </div>
                  <div className="cell-culture-table__title-box__title">
                    <FormattedMessage
                      id="Sample of interest"
                      defaultMessage="Sample of interest"
                      description=""
                    />
                  </div>
                </div>

                <div className="drop-target" id="drop-target">
                  <div className="drop-target__area">
                    {this.props.cellCultures.positiveControl.length == 2 ? (
                      <div id="dropzone-1">
                        <div className="cell-culture">
                          <div>
                            <img
                              draggable="false"
                              aria-label={`Cell culture sample: ${this.parseTypeKey(
                                this.props.cellCultures.positiveControl[0]
                              )}`}
                              src={
                                images[
                                  this.props.cellCultures.positiveControl[0]
                                ]
                              }
                              alt={this.parseTypeKey(
                                this.props.cellCultures.positiveControl[0]
                              )}
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(1, 0);
                              }}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 32)
                                  this.removeCellCulture(1, 0);
                              }}
                            >
                              <img src={close} alt="Remove" />
                            </button>
                          </div>
                          <div>
                            <img
                              draggable="false"
                              aria-label={`Cell culture sample: ${this.parseTypeKey(
                                this.props.cellCultures.positiveControl[1]
                              )}`}
                              src={
                                images[
                                  this.props.cellCultures.positiveControl[1]
                                ]
                              }
                              alt={this.parseTypeKey(
                                this.props.cellCultures.positiveControl[1]
                              )}
                            />
                            <button
                              className="close"
                              aria-label="Remove sample"
                              onClick={() => {
                                this.removeCellCulture(1, 1);
                              }}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 32)
                                  this.removeCellCulture(1, 1);
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : this.props.cellCultures.positiveControl.length == 1 ? (
                      <div id="dropzone-1">
                        <div className="drop-target__area--target">
                          <span>
                            <FormattedMessage
                              id="Drag and drop here"
                              defaultMessage="Drag and drop here"
                              description=""
                            />
                          </span>
                        </div>
                        <div className="cell-culture">
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.positiveControl[0]
                              )}
                              src={
                                images[
                                  this.props.cellCultures.positiveControl[0]
                                ]
                              }
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(1, 0);
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="drop-target__area--target"
                        id="dropzone-1"
                      >
                        <span>
                          <FormattedMessage
                            id="Drag and drop here"
                            defaultMessage="Drag and drop here"
                            description=""
                          />
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="drop-target__area">
                    {this.props.cellCultures.negativeControl.length == 2 ? (
                      <div id="dropzone-2">
                        <div className="cell-culture">
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.negativeControl[0]
                              )}
                              src={
                                images[
                                  this.props.cellCultures.negativeControl[0]
                                ]
                              }
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(2, 0);
                              }}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 32) {
                                  this.removeCellCulture(2, 0);
                                }
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.negativeControl[1]
                              )}
                              src={
                                images[
                                  this.props.cellCultures.negativeControl[1]
                                ]
                              }
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(2, 1);
                              }}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 32) {
                                  this.removeCellCulture(2, 1);
                                }
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : this.props.cellCultures.negativeControl.length == 1 ? (
                      <div id="dropzone-2">
                        <div className="drop-target__area--target">
                          <span>
                            <FormattedMessage
                              id="Drag and drop here"
                              defaultMessage="Drag and drop here"
                              description=""
                            />
                          </span>
                        </div>
                        <div className="cell-culture">
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.negativeControl[0]
                              )}
                              src={
                                images[
                                  this.props.cellCultures.negativeControl[0]
                                ]
                              }
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(2, 0);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  this.removeCellCulture(2, 0);
                                }
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="drop-target__area--target"
                        id="dropzone-2"
                      >
                        <span>
                          <FormattedMessage
                            id="Drag and drop here"
                            defaultMessage="Drag and drop here"
                            description=""
                          />
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="drop-target__area">
                    {this.props.cellCultures.sample.length == 2 ? (
                      <div id="dropzone-0">
                        <div className="cell-culture">
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.sample[0]
                              )}
                              src={images[this.props.cellCultures.sample[0]]}
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(0, 0);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  this.removeCellCulture(0, 0);
                                }
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                          <div>
                            <img
                              draggable="false"
                              alt={this.parseTypeKey(
                                this.props.cellCultures.sample[1]
                              )}
                              src={images[this.props.cellCultures.sample[1]]}
                            />
                            <button
                              className="close"
                              aria-label={this.props.intl.formatMessage({
                                id: "Remove sample",
                                defaultMessage: "Remove sample",
                                description: "",
                              })}
                              onClick={() => {
                                this.removeCellCulture(0, 1);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  this.removeCellCulture(0, 1);
                                }
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : this.props.cellCultures.sample.length == 1 ? (
                      <div id="dropzone-0">
                        <div className="drop-target__area--target">
                          <span>
                            <FormattedMessage
                              id="Drag and drop here"
                              defaultMessage="Drag and drop here"
                              description=""
                            />
                          </span>
                        </div>
                        <div className="cell-culture">
                          <div className="cell-culture">
                            <div>
                              <img
                                draggable="false"
                                alt={this.parseTypeKey(
                                  this.props.cellCultures.sample[0]
                                )}
                                src={images[this.props.cellCultures.sample[0]]}
                              />
                              <button
                                className="close"
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove sample",
                                  defaultMessage: "Remove sample",
                                  description: "",
                                })}
                                onClick={() => {
                                  this.removeCellCulture(0, 0);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.removeCellCulture(0, 0);
                                  }
                                }}
                              >
                                <img src={close} alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="drop-target__area--target"
                        id="dropzone-0"
                      >
                        <span>
                          <FormattedMessage
                            id="Drag and drop here"
                            defaultMessage="Drag and drop here"
                            description=""
                          />
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="horizontal-rule"></div>

            {this.sectionOutcome()}
          </div>

          <button
            tabIndex={0}
            disabled={this.state.predictionProtein == null ? true : false}
            onClick={this.showPredictionPopup}
            type="submit"
          >
            <FormattedMessage
              id="Submit answer"
              defaultMessage="Submit answer"
              description=""
            />
          </button>
        </div>
      </div>
    );
  };

  selectOutCome = (e, imageId) => {
    //if(this.props.predictionProtein == null){
    imageId = e.target.id;

    this.setState({
      predictionProtein: imageId,
    });
    //}
  };

  sectionOutcome = () => {
    return (
      <div>
        <div className="dnd-bg-padding">
          <h5 className="heading5">
            <FormattedMessage
              id="Predict expected outcome"
              defaultMessage="Predict expected outcome"
              description=""
            />
          </h5>

          <p>
            <FormattedMessage
              id="Shown below are representations of four possible outcomes when running a protein gel. Identify which gel has run long enough and is ready for analysis by clicking on it. Visible on the gels are only the pre-stained protein ladder and the blue dye front used in SDS sample buffer. The proteins from the cellular extract are invisible at this stage."
              defaultMessage="Shown below are representations of four possible outcomes when running a protein gel. Identify which gel has run long enough and is ready for analysis by clicking on it. Visible on the gels are only the pre-stained protein ladder and the blue dye front used in SD sample buffer. The proteins from the cellular extract are invisible at this stage."
              description=""
            />
          </p>

          <div className="outcome">
            <div className="outcome__title">
              <label htmlFor="gel-cassette-img"> 1 </label>
              <label htmlFor="gel-cassette-img"> 2 </label>
              <label htmlFor="gel-cassette-img"> 3 </label>
              <label htmlFor="gel-cassette-img"> 4 </label>
            </div>

            <div id="gel-cassette-img" className="outcome__visual-display">
              <div className="outcome__visual-display--img">
                <button
                  id="protein1"
                  style={{
                    border:
                      this.state.predictionProtein === "protein1" ||
                      this.props.predictionProtein === "protein1"
                        ? "5px solid #faac48"
                        : "none",
                  }}
                  onClick={(e) => this.selectOutCome(e, 0)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.selectOutCome(e, 0);
                    }
                  }}
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Top-down view of the gel cassette, Dye front is approximately halfway down the gel; protein ladder is moderately separated out.",
                    defaultMessage:
                      "Top-down view of the gel cassette, Dye front is approximately halfway down the gel; protein ladder is moderately separated out.",
                    description: "",
                  })}
                >
                  <img src={this.gels.protein1.image} alt="" />
                </button>

                <div
                  className="arrow"
                  style={{
                    display:
                      this.props.predictionProtein === "protein1"
                        ? "block"
                        : "none",
                  }}
                ></div>
              </div>

              <div className="outcome__visual-display--img">
                <button
                  id="protein2"
                  style={{
                    border:
                      this.state.predictionProtein === "protein2" ||
                      this.props.predictionProtein === "protein2"
                        ? "5px solid #faac48"
                        : "none",
                  }}
                  onClick={(e) => this.selectOutCome(e, 1)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.selectOutCome(e, 1);
                    }
                  }}
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Top-down view of the gel cassette, Dye front is approximately a quarter of the way down the gel, protein ladder is slightly separated out.",
                    defaultMessage:
                      "Top-down view of the gel cassette, Dye front is approximately a quarter of the way down the gel, protein ladder is slightly separated out.",
                    description: "",
                  })}
                >
                  <img src={this.gels.protein2.image} alt="" />
                </button>

                <div
                  className="arrow"
                  style={{
                    display:
                      this.props.predictionProtein === "protein2"
                        ? "block"
                        : "none",
                  }}
                ></div>
              </div>

              <div className="outcome__visual-display--img">
                <button
                  id="protein3"
                  style={{
                    border:
                      this.state.predictionProtein === "protein3" ||
                      this.props.predictionProtein === "protein3"
                        ? "5px solid #faac48"
                        : "none",
                  }}
                  onClick={(e) => this.selectOutCome(e, 2)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.selectOutCome(e, 2);
                    }
                  }}
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Top-down view of the gel cassette, Dye front is all the way to the bottom of the gel; protein ladder is separated out.",
                    defaultMessage:
                      "Top-down view of the gel cassette, Dye front is all the way to the bottom of the gel; protein ladder is separated out.",
                    description: "",
                  })}
                >
                  <img src={this.gels.protein3.image} alt="" />
                </button>

                <div
                  className="arrow"
                  style={{
                    display:
                      this.props.predictionProtein === "protein3"
                        ? "block"
                        : "none",
                  }}
                ></div>
              </div>

              <div className="outcome__visual-display--img">
                <button
                  id="protein4"
                  style={{
                    border:
                      this.state.predictionProtein === "protein4" ||
                      this.props.predictionProtein === "protein4"
                        ? "5px solid #faac48"
                        : "none",
                  }}
                  onClick={(e) => this.selectOutCome(e, 3)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.selectOutCome(e, 3);
                    }
                  }}
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Top-down view of the gel cassette, Dye front is not visible; protein ladder is very separated out.",
                    defaultMessage:
                      "Top-down view of the gel cassette, Dye front is not visible; protein ladder is very separated out.",
                    description: "",
                  })}
                >
                  <img src={this.gels.protein4.image} alt="" />
                </button>

                <div
                  className="arrow"
                  style={{
                    display:
                      this.props.predictionProtein === "protein4"
                        ? "block"
                        : "none",
                  }}
                ></div>
              </div>
            </div>

            {
              <div>
                <div
                  className="outcome__message"
                  style={{
                    display:
                      this.props.predictionProtein !== null ? "flex" : "none",
                  }}
                >
                  <img
                    src={
                      this.props.predictionProtein == "protein3"
                        ? iconCorrect
                        : iconIncorrect
                    }
                    alt=""
                  />
                  <div className="">
                    {this.props.predictionProtein
                      ? this.gels[this.props.predictionProtein].message
                      : null}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  };

  buildUI = () => {
    return (
      <div className="Predictions">
        <div
          className="outerQBlock"
          onDragStart={this.onDragStart}
          onDragOver={this.onDragOver}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onDragEnd={this.onDrop}
        >
          {this.sectionDragAndDrop()}
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.buildUI()}</div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    cellCultures: state.predictions.cellCultures,
    heldObject: state.predictions.heldObject,
    predictionProtein: state.predictions.predictionProtein,
  };
};

const Predictions10WithIntl = injectIntl(Prediction510);

export default connect(mapStateToProps, {
  setCellCulture,
  setHeldObject,
  removeCellCultureType,
  setGelPrediction,
})((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <Predictions10WithIntl {...props} />
  </TranslationsProvider>
));
